import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { i18n } from 'constant/String';
import { REGEX_PASSWORD } from 'constant/Validation';
import { FormProvider, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import PasswordInfoForm from './PasswordInfoForm';

const PasswordInfoModule = ({ onSubmit }) => {
  const individualSchema = yup
    .object({
      password1: yup
        .string()
        .min(8, i18n.errors.passwordMin)
        .max(50, i18n.errors.passwordMax)
        .matches(REGEX_PASSWORD, i18n.errors.password)
        .required(i18n.errors.required),
      password2: yup
        .string()
        .oneOf([yup.ref('password1'), null], i18n.errors.confirmPassword),
    })
    .required(i18n.errors.required);

  const methods = useForm({
    resolver: yupResolver(individualSchema),
  });

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="flex flex-col overflow-auto w-full gap-y-4 md:mt-10 items-center justify-center  h-full"
      >
        <PasswordInfoForm onSubmit={onSubmit} />
      </form>
    </FormProvider>
  );
};
PasswordInfoModule.propTypes = { onSubmit: PropTypes.func };
export default PasswordInfoModule;
